/**
 * Restrict a number to a minimum and a maximum.
 *
 * "I just want the min of the max of the num and the min and the max." - Jake Archibald
 */
export function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max)
}
